import clsx from "clsx";
import type { ReactNode } from "react";

/** Панель проекта: фон `bg-bg-subtle`, отступ p-4, шапка без линии (в барреле проекта — `Panel`). */
export function PanelCard({
  title,
  aside,
  children,
  annot,
  className,
}: {
  title?: ReactNode | undefined;
  aside?: ReactNode | undefined;
  children: ReactNode;
  annot?: string | undefined;
  className?: string | undefined;
}) {
  return (
    <section
      data-annot={annot}
      className={clsx(
        "rounded-[var(--radius-card)] border border-border bg-bg-subtle p-4",
        className,
      )}
    >
      {title !== undefined || aside !== undefined ? (
        <div className="mb-3 flex items-baseline gap-3">
          {title !== undefined ? <h2 className="text-[14px] font-semibold text-fg">{title}</h2> : null}
          {aside !== undefined ? <div className="ml-auto text-[12px] text-fg-faint">{aside}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
